import PropTypes from 'prop-types';
import { useMemo } from 'react';

import Image from 'components/Image';

import useAdBanner from 'hooks/useAdBanner';

import { sendEvent } from 'lib/gtag';

const LandscapeSponsorAd = ({ ads = [], gaEventCategory }) => {
  const { getAdBannerWithHigherVisibilityPriority } = useAdBanner();

  const ad = useMemo(
    () => getAdBannerWithHigherVisibilityPriority(ads),
    [ads, getAdBannerWithHigherVisibilityPriority]
  );

  const onClick = () => {
    sendEvent({
      action: 'home_ads_banner',
      category: gaEventCategory,
    });
  };

  if (!ad) {
    return null;
  }

  return (
    <a
      className="mx-auto hidden rounded-4 border border-neutral-high-200 dark:border-neutral-low-200 lg:col-start-1 lg:col-end-5 lg:row-start-3 lg:flex"
      href={ad.url}
      rel="noopener noreferrer"
      target="_blank"
      onClick={onClick}
    >
      <Image
        alt={ad.description}
        className="rounded-4"
        height={90}
        src={ad.image}
        width={728}
      />
    </a>
  );
};

LandscapeSponsorAd.propTypes = {
  ads: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      image: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      visibility: PropTypes.string.isRequired,
    })
  ),
  gaEventCategory: PropTypes.string.isRequired,
};

export default LandscapeSponsorAd;
